import { html } from "lit";

export default html`
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M1.4 12A5.6 5.6 0 0 1 7 6.4h10a5.6 5.6 0 1 1 0 11.2H7A5.6 5.6 0 0 1 1.4 12ZM17 16.4a4.4 4.4 0 1 0 0-8.8 4.4 4.4 0 0 0 0 8.8Zm-3.465-8.8A5.59 5.59 0 0 0 11.4 12a5.59 5.59 0 0 0 2.135 4.4H7a4.4 4.4 0 1 1 0-8.8h6.535Z"
      clip-rule="evenodd"
    />
  </svg>
`;
